import { datadogRum } from '@datadog/browser-rum';

if (window.location.hostname.includes('gsafleet.gov')) {
  datadogRum.init({
    applicationId: '2a8899c1-70fc-45ad-97f7-f363ea5aa913',
    clientToken: 'pub6a1592ffefaf4079c13087a2d62c1991',
    site: 'ddog-gov.com',
    service: 'catalog',
    env: 'prod',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    trackSessionAcrossSubdomains: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      if (event.type === 'error' && event.error?.message) {
        const errorMessage = event.error.message;
        const ignoredPatterns = [
          'Resize',
          'Support for defaultProps',
          'usually from the',
        ];
        if (ignoredPatterns.some((pattern) => errorMessage.includes(pattern))) {
          return false;
        }
      }
      return true;
    },
  });
}
